// extracted by mini-css-extract-plugin
export default {"heading":"Elbows_heading__5NO8X","header":"Elbows_header__7a4Sg","subHeading":"Elbows_subHeading__LrDXn"};